var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepperX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "8px",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "15.-Template-02-03",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template-02_Missed-Delivery",
    transform: "translate(-716.000000, -248.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.516364,252 L723.790682,249.725682 C724.069773,249.446591 724.069773,248.994091 723.790682,248.714773 L723.285227,248.209318 C723.006136,247.930227 722.553636,247.930227 722.274318,248.209318 L720,250.483636 L717.725682,248.209318 C717.446591,247.930227 716.994091,247.930227 716.714773,248.209318 L716.209318,248.714773 C715.930227,248.993864 715.930227,249.446364 716.209318,249.725682 L718.483636,252 L716.209318,254.274318 C715.930227,254.553409 715.930227,255.005909 716.209318,255.285227 L716.714773,255.790682 C716.993864,256.069773 717.446591,256.069773 717.725682,255.790682 L720,253.516364 L722.274318,255.790682 C722.553409,256.069773 723.006136,256.069773 723.285227,255.790682 L723.790682,255.285227 C724.069773,255.006136 724.069773,254.553636 723.790682,254.274318 L721.516364,252 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperX);
export default __webpack_public_path__ + "static/media/stepperX.db1a93418eabad931e450c8966a98108.svg";
export { ForwardRef as ReactComponent };